import { exists, translate } from "application/functions";
import getCountry from "module/functions/getCountry";
import { filter, includes, is } from "ramda";

export default function validateAddress(value) {
  const country = getCountry();
  const isFrance = country === "fr";
  const errors = { messages: [], keys: [] };

  const requiredDataKeys = ["address.value", "floor.value", "city.value", "postal_code.value"];

  country === "fr" && requiredDataKeys.push("province_fake.value");

  const unanswered = filter((k) => !exists(value[k]), requiredDataKeys);

  if (exists(unanswered)) {
    // errors.messages = [...errors.messages, translate("error.emptyFields")];
    errors.keys = [...errors.keys, ...unanswered];
  }

  const accept = document.getElementsByName("accept")[0];
  const service = document.getElementsByName("service")[0];
  if (!accept.checked || (isFrance && !service.checked)) {
    errors.messages = [...errors.messages, ...[translate("must.accept")]];
    errors.keys = [...errors.keys, ...["accept"]];
  }

  if (exists(errors.keys)) {
    errors.messages = errors.messages.reduce((acc, m) => {
      return includes(m, acc) ? acc : [...acc, m];
    }, []);
    return errors;
  }
  return null;
}
